export default "__VITE_ASSET__Fg1CfM8n__"